export const FileExtensions = {
  Images: {
    label: "Resim",
    extensions: ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "webp", "svg"],
    accept: "image/*"
  },
  Pdf: {
    label: "PDF",
    extensions: ["pdf"],
    accept: ".pdf"
  },
  Excel: {
    label: "Excel",
    extensions: ["xls", "xlsx", "xlsm", "xlsb", "ods", "csv"],
    accept: ".xls,.xlsx,.xlsm,.xlsb,.ods,.csv"
  },
  Word: {
    label: "Word",
    extensions: ["doc", "docx", "dot", "dotx", "odt", "rtf"],
    accept: ".doc,.docx,.dot,.dotx,.odt,.rtf"
  }
};

// Liste haline getirmek için
export const FileTypes = Object.keys(FileExtensions).map(key => ({
  id: key,
  name: FileExtensions[key].label
}));